import * as React from "react";
import Section from "../../Layout/Section";
import CtaBackground from "./CtaBackground";
import * as styles from "./cta.module.css";
import TemplateString from "../../Common/TemplateString";
import Button from "../../UI/NewButton";
import Media from "../../Common/Media";

const Cta = ({title, description, buttonText, buttonUrl, image}) => {
    return (
        <Section>
            <div className={styles.cta}>
                <div className={styles.cta__content}>
                    <div>
                        <div>
                            <h2 className={styles.cta__title}>
                                <TemplateString template={title} />
                            </h2>
                            <p className={styles.cta__desc}>
                                <TemplateString template={description} />
                            </p>
                        </div>
                        <Button isLink href={buttonUrl} className={styles.cta__button}>
                            {buttonText}
                        </Button>
                    </div>
                    <div className={styles.cta__mediaWrapper}>
                        <Media
                            media={{content: image}}
                            className={styles.cta__media}
                            imageProps={{
                                imgClassName: styles.cta__mediaImage,
                                passClassToSVG: true,
                            }}
                        />
                    </div>
                </div>
                <CtaBackground />
            </div>
        </Section>
    );
};

export default Cta;
